import type { StudentPayload } from "./reportTypes";
import { progressKey } from "@/lib/roadmapProgress";

export default function SavedReportRoadmaps({ payload }: { payload: StudentPayload }) {
  const snapshot = payload.presentation_snapshot;
  if (!snapshot?.roadmaps.length) return null;
  return <div className="mt-6 space-y-6">{snapshot.roadmaps.map(roadmap => {
    const key = progressKey(roadmap.kind, roadmap.archetype, roadmap.band);
    const done = new Set(snapshot.roadmap_state?.progress.filter(p => p.roadmapId === key).map(p => p.milestoneId));
    return <section key={roadmap.kind} className="space-y-4" aria-label={`Saved ${roadmap.kind} roadmap`}>
      <h2 className="font-display text-2xl font-bold">{roadmap.title}</h2>
      <p className="text-sm text-muted-foreground">{done.size} of {roadmap.milestones.length} steps recorded · {roadmap.intro}</p>
      <ol className="space-y-4">{roadmap.milestones.map(m => <li key={m.id} className="border-l-2 border-border pl-4">
        <p className="text-xs text-muted-foreground">{m.phase}{done.has(m.id) ? " · Completed" : ""}</p>
        <h3 className="font-display font-semibold">{m.title}</h3><p className="text-sm text-muted-foreground">{m.why}</p>
        <ul className="mt-2 list-disc space-y-1 pl-5 text-sm">{m.actions.map(a => <li key={a.label}>{a.label} · {a.minutes} min</li>)}</ul>
      </li>)}</ol>
    </section>;
  })}</div>;
}